import PuxTranslate from "../../../../../global/components/PuxTranslate/PuxTranslate.vue";

// @vue/component
export default {
  name: "ModuleNiederschriftPreview",
  components: {
    PuxTranslate,
  },
};
